<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="add">新增</el-button>
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item label="内容类别">
        <el-select v-model="search.category" placeholder="请选择内容类别">
          <el-option label="全部" value="" />
          <el-option v-for="item in categoryList" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="内容分类">
        <el-select v-model="search.type" placeholder="这选择内容分类">
          <el-option label="全部" value="" />
          <el-option v-for="item in contentType" :key="item.id" :label="item.name" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item class="search-form-item">
        <el-input v-model="search.title" placeholder="输入你想搜索的文字" prefix-icon="el-icon-search" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="searchSubmit">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="activity-preorder operation-bar">
      <el-button size="small" type="primary" @click="postOnlineContent('')">
        <svg-icon icon-class="public" />
        立即发布
      </el-button>
    </div>
    <div class="activity-table">
      <tableList ref="multipleTable" size="small" :table-query="search" :query-function="$Api.content.fetchMarketContentList" style="width: 100%" @selection-change="selectionItemChange">
        <el-table-column type="selection" width="55" fixed :selectable="(row) => row.publishedStatus == 0" />
        <el-table-column prop="id" label="内容ID" />

        <el-table-column prop="title" label="内容标题" width="auto" />
        <el-table-column prop="category" label="内容类别">
          <template v-slot="{row}">
            {{ categoryList.find(item=> item.id ===row.category).value || '' }}
          </template>
        </el-table-column>
        <el-table-column prop="type" label="内容分类">
          <template v-slot="{row}">
            {{ contentType.find(item=> item.id ===row.type).name || '' }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="内容状态" width="110">
          <template v-slot="{row}">
            <el-tag :type="contentStatus[row.publishedStatus].color" size="mini">{{ contentStatus[row.publishedStatus].value }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="发布时间" width="150px">
          <template v-slot="{row}">
            {{ formatTime(row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="likeNumber" label="点赞数" />
        <el-table-column prop="collectionNumber" label="收藏数" />

        <el-table-column fixed="right" width="280px" label="操作">
          <template v-slot="{row}">
            <el-button size="small" type="text" class="link-color" @click="edit(row)">编辑</el-button>
            <el-button size="small" type="text" class="link-color" @click="copy(row)">复制</el-button>
            <el-button size="small" type="text" class="link-color" @click="remove(row)">删除</el-button>
            <el-button v-if="row.publishedStatus === 2" size="small" type="text" class="link-color" @click="copyLink(row.id)">复制链接</el-button>
            <el-button v-if="row.publishedStatus === 0" size="small" type="text" class="link-color" @click="postOnlineContent(row.id)">发布</el-button>
            <el-button v-if="row.publishedStatus === 2" size="small" type="text" class="link-color" @click="postOfflineContent(row.id)">下架</el-button>
            <el-button v-if="row.publishedStatus === 2 && row.isTop === 0" size="small" type="text" class="link-color" @click="postStickyContent(row.id)">置顶</el-button>
            <el-button v-if="row.publishedStatus === 2 && row.isTop === 1" size="small" type="text" class="link-color" @click="postUnStickyContent(row.id)">取消置顶</el-button>
          </template>
        </el-table-column>
      </tableList>
      <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSuccess" />
    </div>
  </div>
</template>
<script>
import tableList from '@/components/TableList';
import Dialog from '@/components/Dialog';
import moment from 'moment';
export default {
  components: { tableList, Dialog },
  data() {
    const categoryList = [
      { id: 1, value: '市场内容', color: 'success' },
      { id: 2, value: 'Campaign page', color: 'warning' },
    ];
    const contentStatus = {
      0: { value: '草稿', color: 'warning' },
      2: { value: '已发布', color: 'success' },
    };
    return {
      categoryList,
      contentStatus,
      contentType: [],
      search: {
        category: '',
        type: '',
        title: '',
      },
      selectionId: [],
      formDialogShow: false,
      currentID: -1,
      information: {},
    };
  },
  mounted() {
    this.getTypeList();
  },
  methods: {
    copyLink(id) {
      const input = document.createElement("input"); // 创建input对象
      input.value = process.env.VUE_APP_H5_DOMAIN + 'marketContent/index.html?id=' + id; // 设置复制内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.$message.success("复制成功");
    },
    formatTime(val) {
      if (val) return moment(val).format('YYYY/MM/DD HH:mm:ss');
      return '';
    },
    add() {
      this.$router.push({ path: '/content/add' });
    },
    edit(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'edit',
        icon: 'warn',
        subTitle: `是否确认编辑内容ID为“${row.id}”的数据项？`,
      };
    },
    copy(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'copy',
        icon: 'success',
        subTitle: `复制成功！是否进入新增页面？`,
      };
    },
    remove(row) {
      this.formDialogShow = true;
      this.currentID = row.id;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: '删除后小程序用户将无法查看该内容，请确认是否删除',
      };
    },
    submitSuccess(operation) {
      if (operation === 'delete') {
        this.$Api.content.deleteMarketContent(this.currentID).then(() => {
          this.formDialogShow = false;
          this.$message.success('删除成功');
          this.$refs['multipleTable'].getTableList();
        }).catch(error => {
          this.formDialogShow = true;
          this.information = {
            operation: 'error',
            icon: 'error',
            subTitle: `${error.errorMessage}`,
          };
        });
      } else if (operation === 'copy') {
        this.$router.push({ path: '/content/add', query: { copyid: this.currentID } });
      } else if (operation === 'edit') {
        this.$router.push({ path: '/content/edit', query: { id: this.currentID } });
      }
    },
    // 获取内容分类
    getTypeList() {
      this.$Api.content.fetchTypeList().then(res => {
        this.contentType = res;
      });
    },
    searchSubmit() {
      this.$refs['multipleTable'].searchAndReset();
    },
    reset() {
      this.search = this.$options.data.call(this).search;
      this.$nextTick(() => {
        this.$refs['multipleTable'].searchAndReset();
      });
    },
    // 删除课程
    deleteContent() {
      this.$Api.content.deleteMarketContent(this.currentID).then(() => {
        this.dialogVisible = false;
        this.$message.success('删除成功');
        this.searchSubmit();
      });
    },
    // 上架课程
    postOnlineContent(id) {
      this.$Api.content.postOnlineContent(id ? [id] : this.selectionId).then(() => {
        this.$message.success('上架成功');
        this.searchSubmit();
      });
    },
    // 下架课程
    postOfflineContent(id) {
      this.$Api.content.postOfflineContent([id]).then(() => {
        this.$message.success('下架成功');
        this.searchSubmit();
      });
    },
    // 置顶课程
    postStickyContent(id) {
      this.$Api.content.postStickyContent([id]).then(() => {
        this.$message.success('置顶成功');
        this.searchSubmit();
      });
    },
    // 取消置顶课程
    postUnStickyContent(id) {
      this.$Api.content.postUnStickyContent([id]).then(() => {
        this.$message.success('取消置顶成功');
        this.searchSubmit();
      });
    },
    // 当选择项发生变化时会触发该事件
    selectionItemChange(selection) {
      this.selectionId = selection.reduce((init, item) => {
        init.push(item.id);
        return init;
      }, []);
    },
  },
};
</script>

